/* The small "i" explainer the Studio puts beside a header (Track changes,
   Updates, Variants). The kit tooltip, on a real focusable button, so the
   text reaches keyboard and screen-reader users too (DESIGN §7). */

import React from 'react';
import { Info } from 'lucide-react';
import { Icon } from '../components/ui/Icon';
import { Hint } from '../components/ui/tooltip';

export function InfoHint({ text, label }: { text: string; label: string }) {
  return (
    <Hint text={text} side="bottom">
      <button type="button" className="sps-info-btn" aria-label={`${label}: ${text}`}>
        <Icon icon={Info} em={1} aria-hidden="true" />
      </button>
    </Hint>
  );
}
